<div class="wrapper">
	<div class="header" role="region" aria-label="Header region">
		<ion-icon (click)="dismiss()" src="../../../../assets/icon/cross_white.svg" role="img" aria-label="Close"></ion-icon>
	</div>
	<div [formGroup]="form" role="region" aria-label="Form group">
		<ion-item class="ion-invalid">
			<ion-input formControlName="value" name="value" placeholder="Select Country Name"></ion-input>
		</ion-item>
	</div>
	<div class="country-list" role="region" aria-label="Country list">
		<ng-container *ngFor="let country of countriesArray">
			<ng-container *ngIf="country">
				<div class="country" (click)="dismissWithValue(country)" role="button" tabindex="0">
					<ion-icon
						[src]="'../../../../assets/flag/flags-country/' + country?.flagClass + '.svg'"
						role="img"
						aria-label="Country flag icon"
					></ion-icon>
					<h3>
						{{ country?.name }}
					</h3>
					<div class="selected-circle" role="region" aria-label="Selected circle container">
						<div
							class="inner-circle"
							[class.show]="compareCode(country?.dialCode)"
							role="region"
							aria-label="Inner circle with comparison functionality"
						></div>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</div>
</div>
